import { Button } from "antd";

const BVCancelledButton = () => {
  return (
    <Button
      className="accepted-button"
      type="primary"
      size={"large"}
      disabled={true}
      style={{
        color: "#8B0000",
        borderColor: "#999999",
        backgroundColor: "#d9d9d9",
        paddingInline: "20px"
      }}
    >
      {"Cancelled"}
    </Button>
  );
};

export default BVCancelledButton;